import { render } from "./follow.vue?vue&type=template&id=84cee264&scoped=true&ts=true"
import script from "./follow.vue?vue&type=script&lang=ts"
export * from "./follow.vue?vue&type=script&lang=ts"

import "./follow.vue?vue&type=style&index=0&id=84cee264&lang=less&scoped=true"

import exportComponent from "/builds/workshop/teambition-frontend/node_modules/.pnpm/vue-loader@16.8.3_6zog4g7lmcedlfqueoidvwcx7q/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84cee264"]])

export default __exports__